module.exports = __webpack_public_path__ + "img/Desain Grafika.f4e200da.jpg";